import { RouterProvider } from '@tanstack/react-router';
import { LocaleProvider } from './hooks/useLocale.tsx';
import { ThemeProvider } from './hooks/useTheme.tsx';
import { router } from './router.tsx';

// The marketing site is a lean content SPA: locale + theme providers wrap
// the router, and that's it. No QueryClient, AuthProvider, or Sentry error
// boundary — those belong to the product app and are exactly the weight the
// split keeps off the marketing cold-load path.
export function App() {
  return (
    <LocaleProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </LocaleProvider>
  );
}
